<template>
  <div>
    <div v-if="auditHistory.length>0">
      <el-divider content-position="left">审批历史</el-divider>
      <el-form-item prop="remarks" :key="index" v-for="(item,index) in auditHistory">
        <div slot="label">
          <div>审批人: {{ item.userName }}</div>
          <div style="margin-left: 0px">
            <el-button plain type="primary" size="mini" v-if="item.isAgree==2">审批通过</el-button>
            <el-button plain type="danger" size="mini" v-if="item.isAgree==3">审批拒绝</el-button>
          </div>

        </div>
        <div>
          <div>审批意见</div>
          <el-input type="textarea" v-model=" item.auditOpinion" readonly></el-input>
        </div>
      </el-form-item>
    </div>
    <div v-if="audits.length>0">
      <el-divider content-position="left">当前审批</el-divider>

      <el-form-item prop="remarks" :key="index" v-for="(item,index) in audits">
        <div slot="label">
          <div>审批人: {{ item.userName }}</div>
          <div style="margin-left: 0px">
            <el-button plain type="primary" size="mini" v-if="item.isAgree==2">审批通过</el-button>
            <el-button plain type="danger" size="mini" v-if="item.isAgree==3">审批拒绝</el-button>
          </div>
        </div>
        <div>
          <div>审批意见</div>
          <el-input type="textarea" v-model=" item.auditOpinion" readonly></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuditList",
  props: {
    "audits": Array,
    "auditHistory": Array
  },
  data() {
    return {
      nodes: []
    }
  },
}
</script>

<style scoped>

</style>